import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Welcome from "@/pages/Welcome";
import IntakeFlow from "@/pages/IntakeFlow";
import Resume from "@/pages/Resume";
import Confirmation from "@/pages/Confirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSubmissionDetail from "@/pages/AdminSubmissionDetail";
import { getAdminToken } from "@/lib/api";

function RequireAdmin({ children }) {
    return getAdminToken() ? children : <Navigate to="/admin/login" replace />;
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Welcome />} />
                    <Route path="/intake" element={<IntakeFlow />} />
                    <Route path="/resume" element={<Resume />} />
                    <Route path="/confirmation" element={<Confirmation />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route
                        path="/admin"
                        element={
                            <RequireAdmin>
                                <AdminDashboard />
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="/admin/submissions/:id"
                        element={
                            <RequireAdmin>
                                <AdminSubmissionDetail />
                            </RequireAdmin>
                        }
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#111",
                        border: "1px solid rgba(212,175,55,0.3)",
                        color: "#fff",
                    },
                }}
            />
        </div>
    );
}
